<template>
    <v-row style="height: 100%">
      <v-col cols="12" md="8">
        <v-card light>
          <v-card-text>
            <v-toolbar dense dark>
              <v-tabs slider-size="5" color="pink lighten-1" v-model="tabs">
                <v-tab>
                  {{$t('base.subs')}}
                </v-tab>
                <v-tab>
                  {{$t('base.log')}}
                </v-tab>
              </v-tabs>
            </v-toolbar>
            <v-sheet class="mt-2" light>
              <v-tabs-items v-model="tabs" light>
                <v-tab-item>
                  <user-packets  @refresh="refresh" :account="account"/>
                </v-tab-item>
                <v-tab-item>
                  <account-history class="v-step-2" :id="account.id" />
                </v-tab-item>
              </v-tabs-items>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-col>
        <v-col cols="12" md="4">
          <v-card elevation="12" light>
            <v-card-text>
              <account-info @success="refresh" :account="account" />
            </v-card-text>
          </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import UserPackets from "../packet/UserPackets";
    import AccountInfo from "./AccountInfo";
    import ConfigInstruction from "./ConfigInstruction";
    import AccountHistory from "./AccountHistory";
    export default {
        name: "AccountPanel",
        components : {AccountHistory, UserPackets,AccountInfo,ConfigInstruction},
        props: {
            account: {
                type: Object
            },
        },
      mounted(){

      },
      data() {
        return {
          tabs: null
        }
      },
      methods: {
        refresh() {
          this.$emit('modify')
          this.$refs.cfgs.load()
        }
      },
    }
</script>

<style scoped>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px yellow;
}
</style>